import React, { useState } from "react";
import Navbar from "./Navbar";
import Sidebar from "./Sidebar";
import { Outlet } from "react-router-dom";
import Footer from "./Footer";

function Layout({ children }) {
    const [isSidebarOpen, setSidebarOpen] = useState(true);

    const toggleSidebar = () => {
        setSidebarOpen(!isSidebarOpen);
    };

    return (
      <>
      
        <div className={` ${isSidebarOpen ?  '' : 'sidebar-collapsed'}`}>
            <Navbar toggleSidebar={toggleSidebar} />
            <Sidebar isOpen={isSidebarOpen} />
                {children}
                <Outlet/>
                <Footer/> 
        </div>
        </>
    );
}

export default Layout;
